<script setup>
defineProps({ url: { type: String, default: null } });
</script>

<template>
    <a v-if="url" :href="url" class="btn btn-primary" target="_blank" rel="noopener noreferrer">
        <i class="bi bi-printer me-1" aria-hidden="true"></i>Print / share<span class="visually-hidden"> in a new tab</span>
    </a>
</template>
